/*
 * Author: Dw
 * File Created: Friday, 24-08-23 04:24 pm
 * Last Modified: Thursday, 25-03-06 11:10 am, by Ben Zhao
 */

import { Logger } from '@web/utils';

export const logger = new Logger({
  module: '@web/http',
});
